import * as React from 'react';

import FuncionalidadeService from '../../../services/FuncionalidadesService';
import { BaSeDialogContext } from '@base/react';
import { DEFAULT_VALUE_SELECIONE } from './addFuncionalidade';
import FuncionalidadesService from '../../../services/FuncionalidadesService';
// import AdministradoresService from '../../../services/AdministradoresService';
// import { inTemporaryStore } from '../../../utils/storage.util';
import { DEFAULT_VALUE_ALL } from './addFuncionalidade';

import { BaSeTheme } from '@base/react';

import { useDebounce } from '@base/react';

// import XLSX from 'xlsx';

export const AddFuncionalidadesModel = ({
  selectedRow,
  typeScreen,
  onClose,
  funcoes,
}) => {
  const [tipoPessoa, setTipoPessoa] = React.useState('PESSOA_FISICA');
  const [funcionalidade, setFuncionalidade] = React.useState({
    tipoPessoa: tipoPessoa,
  });
  const [planilha, setPlanilha] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoadingCidades, setIsLoadingCidades] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [cidades, setCidades] = React.useState([]);
  const { showModal } = React.useContext(BaSeDialogContext);
  const [isCPF, setIsCPF] = React.useState(true);
  const [newCPF, setNewCPF] = React.useState('');
  const [newCNPJ, setNewCNPJ] = React.useState('');

  const [funcoesBackup, setFuncoesBackup] = React.useState(funcoes);
  // const [userCPF, setUserCPF] = React.useState(
  //   inTemporaryStore.getItem('usuario')?.cpf
  // );

  const filterMenu = (value) => {
    const tmp =
      value === DEFAULT_VALUE_ALL
        ? funcoes
        : funcoes.filter((fun) => fun.menu === value);
    setFuncionalidade({ ...funcionalidade, menu: value });
    setFuncoesBackup(tmp);
  };

  const addNotificacao = async (funcionalidade) => {
    let payload = {
      ...funcionalidade,
    };

    const response =
      typeScreen === 3
        ? await FuncionalidadesService.updateFuncionalidade(payload)
        : await FuncionalidadesService.addFuncionalidade(payload);

    const Sim = 'OK';
    let config;

    if (response.status !== 200) {
      const actions = {
        [Sim]: () => console.log('Ação do modal: SIM'),
      };
      const content = () => {
        // console.log('1', response?.response?.data);
        if (
          response?.response?.data?.message.includes(
            'Já existe uma funcionalidade cadastrada com o nome'
          )
        ) {
          return (
            <text>
              A funcionalidade não foi <strong>incluída</strong>. Essa
              funcionalidade já existe em nosso banco de dados!
            </text>
          );
        }
        return (
          <text>
            A funcionalidade não foi{' '}
            <strong>{typeScreen !== 3 ? 'incluída' : 'editada'}</strong>.
            Sistema temporariamente fora ar. Tente novamente mais tarde.
          </text>
        );
      };
      config = {
        // Entradas
        actions: [
          {
            action: Sim,
            type: 'primary',
            color: BaSeTheme.colors.feedbackInterface.erro45,
          },
        ],
        title: 'Erro',
        titleColor: BaSeTheme.colors.institucionais.erro45, // Quando não passar, assume-se o valor #617385
        dismissable: true, // Quando não passar, assume-se o valor `true`
        content: () => content(),
        onOpen: () => console.log('>>> Abriu a modal'),
        onChooseAction: (action) => actions?.[action]?.(),
        onDismiss: () =>
          console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
        afterClose: () => console.log('>>> Modal fechada'),
      };
    } else {
      const actions = {
        [Sim]: () => onClose(),
      };

      config = {
        // Entradas
        actions: [
          {
            action: Sim,
            type: 'primary',
            color: BaSeTheme.colors.feedbackInterface.sucesso,
          },
        ],
        title: 'Salvo',
        titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45, // Quando não passar, assume-se o valor #617385
        dismissable: true,
        content: () => (
          <text>
            A funcionalidade foi{' '}
            <strong>{typeScreen !== 3 ? 'incluída' : 'editada'}</strong> com
            sucesso.
          </text>
        ),
        // Eventos
        onOpen: () => console.log('>>> Abriu a modal'),
        // onOpen: () => console.log('1', response?.response),
        onChooseAction: (action) => actions?.[action]?.(),
        onDismiss: () =>
          console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
        afterClose: () => console.log('>>> Modal fechada'),
      };
    }

    showModal(config);

    return response;
  };

  const updateCidades = async (sigla) => {
    const cidadesResp = await FuncionalidadeService.getCidades(
      sigla?.[0]?.sigla
    );

    delete cidadesResp?.data?.[0]?.uf;
    setCidades(cidadesResp?.data ?? []);
  };

  const clearCidades = () => setCidades([]);

  React.useEffect(() => {
    const updateFunc = async () => {
      let tmp = {};
      if (typeScreen === 3 || typeScreen === 4) {
        tmp = {
          ...selectedRow,
        };
        tmp.idFuncao = tmp.funcao.id;
        delete tmp.funcao;
        setFuncionalidade(tmp);
        if (tmp.tipoPessoa === 'PESSOA_JURIDICA')
          setTipoPessoa('PESSOA_JURIDICA');
        if (tmp?.cidade) {
          setIsLoadingCidades(true);
          await updateCidades(tmp.uf.sigla);
          setIsLoadingCidades(false);
        }
      }
    };
    updateFunc();

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateValue = async (attr, value) => {
    const tmp = { ...funcionalidade };
    tmp[attr] = value;

    setFuncionalidade(tmp);
  };

  const removeCPF = (index) => {
    const filtered = [...planilha];
    filtered.splice(index, 1);

    setPlanilha(filtered);
  };

  const updatePlanilha = async (event) => {
    // const reader = new FileReader();
    // // Loop Over Each Sheet
    // reader.onload = () => {
    //   const data = reader.result;
    //   const workBook = XLSX.read(data, { type: 'binary' });
    //   const jsonData = workBook.Sheets[workBook.SheetNames[0]];
    //   const arrayFinal = Object.keys(jsonData)
    //     .filter((fil) => typeof jsonData[fil] === 'object' && jsonData[fil].v)
    //     .map((val) => jsonData[val].v);
    //
    //   const tmp = [...arrayFinal, ...(planilha ?? [])];
    //   setPlanilha(tmp);
    // };
    // reader.readAsBinaryString(event.target.files[0]);
  };

  const cleanBody = (values) => {
    const tmp = Object.keys(values)
      .filter((val) => {
        const value = Array.isArray(values[val]) ? values[val][0] : values[val];
        return value && value !== DEFAULT_VALUE_SELECIONE;
      })
      .reduce((res, key) => {
        return {
          ...res,
          [key]: values[key],
        };
      }, {});

    return tmp;
  };

  const adicionarNotificacao = async () => {
    if (
      !!funcionalidade.nome &&
      !!funcionalidade.descricao &&
      !!funcionalidade.menu &&
      !!funcionalidade.palavrasChave &&
      !!funcionalidade.parceiro &&
      !!funcionalidade.idFuncao
    ) {
      const { administradores, arquivo, ...restOfValues } = funcionalidade;
      const tmpSend = cleanBody(restOfValues);
      if (typeScreen !== 3) delete tmpSend.id;
      setIsLoading(true);
      await addNotificacao(tmpSend);
      setIsLoading(false);
    } else {
      const labelYup = 'OK';
      const actions = {
        [labelYup]: () => console.log('Ação do modal: SIM'),
      };
      const config = {
        // Entradas
        actions: [
          {
            action: labelYup,
            type: 'primary',
            color: BaSeTheme.colors.feedbackInterface.erro45,
          },
        ],
        title: 'Preencha os campos',
        titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45, // Quando não passar, assume-se o valor #617385
        dismissable: true, // Quando não passar, assume-se o valor `true`
        content: () => <>Campos obrigatórios não preenchidos</>,
        onOpen: () => console.log('>>> Abriu a modal'),
        onChooseAction: (action) => actions?.[action]?.(),
        onDismiss: () =>
          console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
        afterClose: () => console.log('>>> Modal fechada'),
      };

      showModal(config);
    }
  };

  const recoveredByid = (arrayToFind, idFind, mustReturnInArray) => {
    const recovered = arrayToFind.find((fcl) => fcl.id === parseInt(idFind));
    const recoveredResp = mustReturnInArray ? [recovered] : recovered;
    return recoveredResp;
  };

  const onChangeUF = async (ufsArray, value) => {
    // nao fazer requisicao quando escolher o selecione
    if (value !== DEFAULT_VALUE_SELECIONE) {
      const ufById = recoveredByid(ufsArray, value, true);
      updateValue('ufs', ufById);
      updateCidades(ufById);
    } else {
      clearCidades();
    }
  };

  const updatePics = async (title, event) => {
    const file = event.target.files[0]; // FileList object
    const reader = new FileReader();
    const nameSplit = file.name.split('.').pop();

    reader.onload = (e) => {
      const binaryData = e.target.result;
      const base64String = window.btoa(binaryData);
      updateValue(title, {
        base64: base64String,
        contentType: file.type,
        extensao: nameSplit,
      });
    };

    reader.readAsBinaryString(file);
  };

  const toDataURL = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  const getBase64 = async (url) => {
    let base64 = await toDataURL(url);
    return base64;
  };

  return {
    funcionalidade,
    setFuncionalidade,
    isLoadingCidades,
    setIsLoadingCidades,
    error,
    setError,
    addNotificacao,
    cidades,
    updateCidades,
    clearCidades,
    isLoading,
    setIsLoading,
    updateValue,
    adicionarNotificacao,
    onChangeUF,
    updatePics,
    useDebounce,
    recoveredByid,
    // setUserCPF,
    getBase64,
    isCPF,
    setIsCPF,
    planilha,
    setPlanilha,
    removeCPF,
    funcoesBackup,
    setFuncoesBackup,
    newCPF,
    newCNPJ,
    setNewCPF,
    filterMenu,
    setNewCNPJ,
    updatePlanilha,
    tipoPessoa,
    setTipoPessoa,
  };
};
